import { render, staticRenderFns } from "./IssueBox.vue?vue&type=template&id=37aa6422&scoped=true&"
import script from "./IssueBox.vue?vue&type=script&lang=js&"
export * from "./IssueBox.vue?vue&type=script&lang=js&"
import style0 from "./IssueBox.vue?vue&type=style&index=0&id=37aa6422&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa6422",
  null
  
)

export default component.exports